export const getCurrentDomainId = (domains) => {
	if (typeof window === 'undefined') return null;

	try {
		const currentHostname =
			process.env.NODE_ENV === 'development'
				? process.env.REACT_APP_DOMAIN_DEFAULT_HOST_NAME
				: window.location.hostname;
		const singleDomain = domains.find(
			(d) => d.is_active && d.url.includes(currentHostname)
		);

		return singleDomain?.id;
	} catch (error) {
		throw Error('Domain not found');
	}
};
